import LegalPageLayout from "@/components/legal/LegalPageLayout";

export default function Terms() {
  return (
    <LegalPageLayout title="Terms &amp; Conditions" testId="terms-page">
      <p>
        These Terms &amp; Conditions govern your use of the AMTM Rescue Hub website (this "Site"), operated by
        Animal Matter To Me ("AMTM", "we", "us"). By using this Site or making a donation through it, you agree
        to these terms.
      </p>

      <h2>1. About AMTM</h2>
      <p>
        AMTM is a registered animal welfare NGO based in Mumbai, India, working to rescue, treat, and rehabilitate
        injured and abandoned street animals. Our registration details are published on our{" "}
        <a href="/transparency">Transparency page</a>.
      </p>

      <h2>2. Donations</h2>
      <p>
        Donations made through this Site are processed by our third-party payment processor, Razorpay. AMTM does
        not store your card, UPI, or bank details. One-time donations and monthly "Guardian" recurring donations
        are both voluntary contributions towards our rescue and sheltering work.
      </p>
      <p>
        We accept donations only from Indian residents/citizens on this Site, in compliance with the Foreign
        Contribution (Regulation) Act, 2010 ("FCRA"). See our <a href="/contact">Contact Us</a> page for
        international giving.
      </p>

      <h2>3. Use of funds</h2>
      <p>
        Donations are used towards veterinary care, sheltering, feeding, and rehabilitation of rescued animals, and
        towards the operating costs of running these programmes. See our <a href="/transparency">Transparency
        page</a> for our fund-usage policy on case-specific and general giving.
      </p>

      <h2>4. No guarantee of outcome</h2>
      <p>
        While we make every reasonable effort to use donations as described, AMTM cannot guarantee a specific
        medical outcome for any individual animal. Rescue and veterinary care inherently involve uncertainty.
      </p>

      <h2>5. Recurring donations (Guardians)</h2>
      <p>
        Monthly Guardian donations continue automatically each billing cycle until you cancel. You can cancel
        anytime via your donor portal or by writing to us - see our{" "}
        <a href="/refund-policy">Refund &amp; Cancellation Policy</a>.
      </p>

      <h2>6. Intellectual property</h2>
      <p>
        All content on this Site, including text, photographs of rescued animals, and branding, is owned by AMTM
        or used with permission, and may not be reproduced without our written consent.
      </p>

      <h2>7. Limitation of liability</h2>
      <p>
        This Site is provided "as is". AMTM is not liable for any indirect or consequential loss arising from your
        use of this Site, to the fullest extent permitted by Indian law.
      </p>

      <h2>8. Governing law</h2>
      <p>These terms are governed by the laws of India, with courts in Mumbai, Maharashtra having jurisdiction.</p>

      <h2>9. Changes to these terms</h2>
      <p>We may update these terms from time to time; the current version will always be published on this page.</p>

      <p>Questions about these terms? Please reach us via our <a href="/contact">Contact Us</a> page.</p>
    </LegalPageLayout>
  );
}
